import React from "react";
import NetlifyForm from 'react-netlify-form'
import Loader from './loader'

const contactForm = () => {
  return (
    <div>
      <div className="contact-content">
          <div className="contact-form contact-form-mobile">
            <div className="form content">
            <NetlifyForm name='contact'>
            {({ loading, error, success }) => (
                <div>
                {loading &&
                    <div className="loader"> <Loader/></div>
                }
                {error &&
                    <div>Your information was not sent. Please try again later.</div>
                }
                {success &&
                    <div><h2>Thank you for contacting us!</h2></div>
                }
                {!loading && !success &&
                <div>
                  <label>
                    <input
                      className="name"
                      name="Name"
                      type="text"
                      placeholder="Name*"
                      required
                    />
                  </label>
                  <br />
                  <br />
                  <label>
                    <input
                      className="email"
                      name="Email"
                      type="text"
                      placeholder="Email*"
                      required
                    />
                  </label>
                  <br />
                  <br />
                  <label>
                    <input
                      className="subject"
                      type="text"
                      name="Subject"
                      placeholder="Subject*"
                      required
                    />
                  </label>
                  <br />
                  <br />
                  <label>
                    <textarea
                      className="message"
                      name="Message"
                      placeholder="Message*"
                      required
                    ></textarea>
                  </label>
             
                <br />
                <br />
          
                  <button type="submit">
                    <p className="submit">Submit</p>
                  </button>
                  </div>
                 }
                </div>
                )}
                </NetlifyForm>
            </div>
          </div>
       
      </div>
        <style jsx="true">
          {`
                  .contact-content {
                    position: relative;
                    // background:linear-gradient(
                    //     to right, rgba(35,62,148, 0.9), rgba(58,157,175, 1)), url("https://images.unsplash.com/photo-1524503033411-c9566986fc8f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1650&q=80") center center no-repeat;
                    // background-size: cover;
                    // background-attachment: fixed;
                    color: white;
                    display: flex;
                    justify-content: center;
                    vertical-align: middle;
                    align-items: center;
                    z-index: 99;
                    margin-top: 2rem;
                }
                h2 {
                   
                    font-size: 2rem;
                    text-align: center;
                    color: #f69c1f;
                }
                .form button {
                   float: left !important;
                   width: 40%;
                   background: transparent;
                   border: 2px solid rgba(35,62,148, 0.7);
                   outline: none;
                }
         
                .contact-form .submit {
                    padding-right: 0 !important;
                    font-size: 16px !important;
                }
                .contact-form .content .owner-name {
                    color: #233E94;
                    font-weight: bold;
                }
         
                .contact-form .form .name {
                    width: 100%;
                    height: 35px;
                    background: transparent;
                    border-radius: 10px;
                    border: 2px solid rgba(35,62,148, 0.7);
                    padding: 0 10px;
                    font-size: 15px;
                    color:  rgba(35,62,148, 0.7);
    
                    // box-shadow: 0 20px 30px -14px rgba(0,0,0,0.5);
                    // font-family: 'Open Sans Condensed', sans-serif;
                }
                .contact-form .form .name:focus {
                    outline: none;
                }
                
                .contact-form .form .email,
                .contact-form .form .subject {
                    background: transparent;
                    border-radius: 10px;
                    border: 2px solid rgba(35,62,148, 0.7);
                    padding: 0 10px;
                    font-size: 15px;
                    color:  rgba(35,62,148, 0.7);
                    // box-shadow: 0 20px 30px -14px rgba(0,0,0,0.3);
                    width: 100%;
                    height: 35px;
                    // font-family: 'Open Sans Condensed', sans-serif;
                }
                .contact-form .form .email:focus,
                .contact-form .form .subject:focus {
                    outline: none;
                }
                .message {
                    width: 100%;
                    background: transparent;
                    border: 2px solid rgba(35,62,148, 0.7);
                    border-radius: 10px;
                    padding: 10px 10px;
                    min-height: 120px;
                    font-size: 15px;
                    color:  rgba(35,62,148, 0.7);
                    
                }
                .message:focus {
                    outline: none;
                }
                .contact-form ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
                    color:  rgba(35,62,148, 0.7);
                }
                .contact-form ::-ms-input-placeholder { /* Internet Explorer 10-11 */
                    color:  rgba(35,62,148, 0.7);
                  }
                  
                .contact-form ::-ms-input-placeholder { /* Microsoft Edge */
                    color:  rgba(35,62,148, 0.7);
                  }
    
                button {
                    border-radius: 10px;
                }
                .submit {
                    color:  rgba(35,62,148, 0.7);
                }
   
    

            .contact-form {
                width: 70vw;
                float: right;
                text-align: center;
                padding: 0 100px;
                color: #212121;
            }
            .contact-form .content p {
                font-size: 24px;
                padding-right: 50px;
            }
            .contact-form .content .owner-name {
                color: #39e1ff;
                font-weight: bold;
            }

            @media screen and (max-width: 760px) {
  
                .contact-form {
                    position: relative;
                    width: 100% !important;
                    float: none;
                    display: block;
                    margin: auto;
                    padding: 0;

                }
                
                .contact-form .form .name,
                .contact-form .form .email,
                .contact-form .form .company,
                .contact-form .form .subject,
                .contact-form .form .message {
                    padding: 0 4px;
                    margin: 0 auto;
                    width: 100%;
            }
            .contact-form .form .message {
                padding: 6px 4px;
            }

            .form button {
                width: 100%;
             }

                .contact-form .content p {
                    padding: 0;
                }
            }
            `}
        </style>
    </div>
  );
};

export default contactForm;
